"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBigInt = void 0;
exports.isBigInt = (value) => typeof value === "bigint";
//# sourceMappingURL=is-bigint.js.map